export enum StatusCode {
  Finished = 200630001,
  Future = 1,
  InProgress = 200630002,
}
